"use strict";
exports.__esModule = true;
require("../comment-box-form.css");
var comment_box_form_1 = require("../comment-box-form");
var probability_form_1 = require("../probability-form/probability-form");
var range_form_1 = require("../range-form/range-form");
var RichTextBox = /** @class */ (function () {
    function RichTextBox(val) {
        this.val = val;
    }
    RichTextBox.prototype.toCommentStr = function () {
        var comment = this.val;
        var parsedHTML = $.parseHTML(comment);
        var parsedComment = (parsedHTML && parsedHTML.length && this.getTextContent(parsedHTML[0]) !== undefined)
            ? this.parseHTMLtoString(comment) : comment;
        return this.trimComment(parsedComment);
    };
    RichTextBox.prototype.toCommentForm = function (formType) {
        var form = this.buildForm();
        var msg = isEmptyForm(form) ? '' : JSON.stringify({ form: form });
        if (formType == 'Probability') {
            return new probability_form_1.ProbabilityForm(msg);
        }
        else if (formType == 'Range') {
            return new range_form_1.RangeForm(msg);
        }
        else {
            console.warn("Invalid comment form type!");
        }
    };
    RichTextBox.prototype.buildForm = function () {
        var _this = this;
        var grids = this.val.split(comment_box_form_1.Splitter);
        var formMap = {};
        var _loop_1 = function (grid) {
            var gridComponents = $.parseHTML(grid);
            if (gridComponents && gridComponents.length && this_1.getTextContent(gridComponents[0]) !== undefined) {
                var keyElem = gridComponents[0].firstChild;
                if (keyElem && (keyElem.nodeName === 'B' || keyElem.nodeName === 'STRONG') &&
                    this_1.getTextContent(gridComponents[0]) !== this_1.getTextContent(keyElem)) {
                    var keyName = this_1.getTextContent(keyElem);
                    var fullContent_1 = '';
                    gridComponents.forEach(function (elem) { return (fullContent_1 += _this.getTextContent(elem)); });
                    if (keyName !== fullContent_1) {
                        var val = fullContent_1.slice(keyName.length + 2); // get value by removing key name and the first 2 characters, which is ': '
                        formMap[keyName] = { comment: val };
                    }
                }
                else {
                    if (!formMap['Others'])
                        formMap['Others'] = { comment: '' };
                    var fullContent_2 = '';
                    gridComponents.forEach(function (elem) { return (fullContent_2 += _this.getTextContent(elem)); });
                    formMap['Others']['comment'] += fullContent_2;
                }
            }
            else {
                if (!formMap['Others'])
                    formMap['Others'] = { comment: '' };
                formMap['Others']['comment'] += grid;
            }
        };
        var this_1 = this;
        for (var _i = 0, grids_1 = grids; _i < grids_1.length; _i++) {
            var grid = grids_1[_i];
            _loop_1(grid);
        }
        return formMap;
    };
    RichTextBox.prototype.isEmpty = function () {
        return this.trimComment(this.val) === '';
    };
    RichTextBox.prototype.parseHTMLtoString = function (comment) {
        var str = "";
        var parsedComment = $.parseHTML(comment);
        for (var i = 0; i < parsedComment.length; i++) {
            str += this.getTextContent(parsedComment[i]) + " ";
        }
        return str.trim();
    };
    RichTextBox.prototype.getTextContent = function (element) {
        if (!element) {
            return undefined;
        }
        if (typeof element['outerText'] !== 'undefined') {
            return element['outerText'];
        }
        return element['textContent'];
    };
    RichTextBox.prototype.trimComment = function (comment) {
        if (comment && comment.length > 50) {
            comment = comment.substring(0, 49) + "...";
        }
        return comment;
    };
    return RichTextBox;
}());
exports.RichTextBox = RichTextBox;
function isEmptyForm(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
//# sourceMappingURL=rich-text-box.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/comment-box/rich-text-box/rich-text-box.js